import { ErrorOutline } from '@mui/icons-material';
import { Box, Button, Card, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface LocationState {
  message?: string;
  hideBackButton?: boolean;
}

function ErrorPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const state = location.state as LocationState | null;
  const errorMessage = state?.message || 'Unexpected error occurred, please try again later.';
  const hideBackButton = state?.hideBackButton || false;

  useEffect(() => {
    // Trigger error for Sentry to catch
    try {
      throw new Error(`Error page loaded: ${errorMessage}`);
    } catch (error) {
      // Let Sentry catch the error
      console.error('Error page error for Sentry:', error);
      //   throw error;
    }
  }, [errorMessage]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '92vh',
        backgroundColor: '#F6F9FC'
      }}>
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          padding: 4,
          textAlign: 'center',
          boxShadow: 3,
          borderRadius: 2
        }}>
        <Box sx={{ marginBottom: 1 }}>
          <ErrorOutline
            sx={{
              fontSize: 64,
              color: 'error.main',
              marginBottom: 1
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            marginBottom: 2,
            color: 'text.primary'
          }}>
          Something went wrong
        </Typography>

        <Typography
          variant="body1"
          sx={{
            marginBottom: 4,
            color: 'text.secondary',
            lineHeight: 1.6
          }}>
          {errorMessage}
        </Typography>

        {!hideBackButton && (
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button variant="outlined" onClick={handleGoBack} sx={{ minWidth: 120 }}>
              Go Back
            </Button>
          </Box>
        )}
      </Card>
    </Box>
  );
}

export default ErrorPage;
